import React, { useRef } from 'react';

const ProjectCard = ({ prjLink, imgURL, desc, title, isUpcoming, isBeta, featured, stat }) => {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    card.style.transform = `perspective(700px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) scale(1.02)`;
  };

  const handleMouseLeave = () => {
    if (cardRef.current) cardRef.current.style.transform = '';
  };

  if (isUpcoming) {
    return (
      <div className="project-card upcoming">
        <div className="project-img-wrap">
          <img src={imgURL} alt={title} />
        </div>
        <div className="project-info">
          <div className="project-title-row">
            <span className="project-title">{title}</span>
            <span className="project-badge upcoming">Soon</span>
          </div>
          <p className="project-desc">{desc}</p>
        </div>
      </div>
    );
  }

  if (featured) {
    return (
      <a href={prjLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'block' }}>
        <div
          ref={cardRef}
          className="project-card project-card--featured"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          style={{ transition: 'transform 0.18s ease, box-shadow 0.3s, border-color 0.3s' }}
        >
          <div className="project-img-wrap project-img-wrap--featured">
            <img src={imgURL} alt={title} />
            <div className="project-featured-label">Featured</div>
            {stat && <div className="project-stat-badge">{stat}</div>}
          </div>
          <div className="project-info">
            <div className="project-title-row">
              <span className="project-title">{title}</span>
            </div>
            <p className="project-desc">{desc}</p>
            <span className="project-link-hint">View project →</span>
          </div>
        </div>
      </a>
    );
  }

  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="project-img-wrap flip-img">
            <img src={imgURL} alt={title} />
          </div>
          <div className="flip-front-info">
            <span className="project-title">{title}</span>
            {isBeta && <span className="project-badge beta">Beta</span>}
          </div>
          <p className="flip-front-desc">{desc}</p>
        </div>
        <div className="flip-card-back">
          <p className="flip-back-title">{title}</p>
          <p className="flip-back-desc">{desc}</p>
          <a
            href={prjLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flip-back-link"
            onClick={e => e.stopPropagation()}
          >
            View Project →
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
